const RouteNames = {
   headOfAccounts: "/settings/head-of-accounts",

   // LANDING PAGE
   landingGallery: "/gallery", 

   // USER
   userAddForm: "/user/add-user",
   userList: "/user/view",
   userEdit: "/user/update-user/:id",

   // ROLE MASTER
   roleMasterAddForm: "/role-master/add-form",
   roleMasterList: "/role-master/list",
   roleMasterAdd: "/role-master/add",
   roleMasterEdit: "/role-master/add-edit/:id",

   // PERMISSION MASTER
   permissionMasterList: "/permission-master/list",
   permissionMasterAdd: "/permission-master/add",
   permissionMasterEdit: "/permission-master/edit/:id",

   // FLEET MASTER
   fleetMasterAddForm: "/fleet-master/add-form",
   fleetMasterList: "/fleet-master/list",
   fleetMasterEdit: "/fleet-master/edit/:id",
   fleetMasterView: "/fleet-master/view/:id",
   fleetMaintenance: "/fleet-maintenance",
   fleetMaintenanceVehicle: "/fleet-maintenance/:id",
   vehicleTracking: "/vehicle-tracking",

   // KILOLETER MASTER UNDER FLEET MASTER
   kiloleterMasterAddForm: "/fleet-master/kiloleter-master/add",
   kiloleterMasterView: "/fleet-master/kiloleter-master/list",
   kiloleterMasterEdit: "/fleet-master/kiloleter-master/edit/:id",

   // Tonnage MASTER UNDER FLEET MASTER
   tonnageMasterAddForm: "/fleet-master/tonnage/add",
   tonnageMasterView: "/fleet-master/tonnage/list",
   tonnageMasterEdit: "/fleet-master/tonnage/edit/:id",

   // Vehicle Category MASTER UNDER FLEET MASTER
   vehicleCategoryMasterAddForm: "/fleet-master/vehicle-category/add",
   vehicleCategoryMasterView: "/fleet-master/vehicle-category/list",
   vehicleCategoryMasterEdit: "/fleet-master/vehicle-category/edit/:id",

   // PAYROLL MASTER
   payrollMasterListAddForm: "/payroll-master/payroll-list/add-form",
   payrollMasterListView: "/payroll-master/payroll-list/view",
   payrollMasterListEdit: "/payroll-master/payroll-list/edit/:id",
   payrollMasterListDetails: "/payroll-master/payroll-list/details/:id",

   payrollStructureAddForm: "/payroll-master/payroll-structure/add-form",
   payrollStructureView: "/payroll-master/payroll-structure/view",
   payrollStructureEdit: "/payroll-master/payroll-structure/edit/:id",
   payrollStructureDetails: "/payroll-master/payroll-structure/details/:id",

   // DRIVER MASTER
   driverMasterAddForm: "/driver-master/add-form",
   driverMasterView: "/driver-master/view",
   driverMasterEdit: "/driver-master/edit/:id",
   driverMasterDetails: "/driver-master/details/:id",
   fleetAssignment: "/driver-master/fleet-assignment",

   // HELPER MASTER
   helperMasterAddForm: "/helper-master/add-form",
   helperMasterView: "/helper-master/view",
   helperMasterEdit: "/helper-master/edit/:id",
   helperMasterDetails: "/helper-master/details/:id",

   // CUSTOMER MASTER
   customerMasterAddForm: "/customer-master/add-form",
   customerMasterView: "/customer-master/view",
   customerMasterEdit: "/customer-master/edit/:id",
   customerMasterDetails: "/customer-master/details/:id",
   customerMasterLaneEdit: "/customer-master/lane/edit/:id",

   // VENDOR MASTER
   vendorMasterAddForm: "/vendor-master/add-form",
   vendorMasterView: "/vendor-master/view",
   vendorMasterEdit: "/vendor-master/edit/:id",

   // LANE MASTER
   LaneMasterAddForm: "/lane-master/add-form",
   laneMasterView: "/lane-master/view",
   laneMasterEdit: "/lane-master/edit/:id",

   // CONTRACTOR MASTER
   ContractorMasterAddForm: "/contractor-master/add-form",
   contractorMasterView: "/contractor-master/view",
   contractorMasterEdit: "/contractor-master/edit/:id",
   contractorMasterDetails: "/contractor-master/details/:id",

   // LOCATION MASTER
   LocationMasterAddForm: "/location-master/:formType",
   LocationMasterView: "/location-master/view",
   LocationMasterEdit: "/location-master/:formType/:id",

   // Node MASTER
   NodeMasterAddForm: "/node-master/:formType",
   NodeMasterView: "/node-master/view",
   NodeMasterEdit: "/node-master/:formType/:id",

   // ROUTE MASTER
   routeMasterAddForm: "/route-master/add-form",
   routeMasterView: "/route-master/view",
   routeMasterEdit: "/route-master/edit/:id",

   // PRODUCT CATEGORY MASTER
   productCategoryMasterAddForm: "/product-master/category/add-form",
   productCategoryMasterView: "/product-master/category/view",
   productCategoryMasterEdit: "/product-master/category/edit/:id",

   // PRODUCT MASTER
   productMasterAddForm: "/product-master/add-form",
   productMasterView: "/product-master/view",
   productMasterEdit: "/product-master/edit/:id",

   // CONSIGNMENT MASTER
   consignmentMasterAddForm: "/consignment-master/add-form",
   consignmentMasterView: "/consignment-master/view",
   consignmentMasterDetails: "/consignment-master/details/:id",
   consignmentMasterInvoice: "/consignment-master/invoice/:id",
   consignmentMasterLR: "/consignment-master/lr/:id",
   consignmentMasterEdit: "/consignment-master/edit/:id",

   // PART CONSIGNMENT MASTER
   partConsignmentMasterAddForm: "/part-consignment-master/add-form",
   partConsignmentMasterAddWithParent: "/part-consignment-master/add-form/:parentId",
   partConsignmentMasterView: "/part-consignment-master/view",
   partConsignmentMasterDetails: "/part-consignment-master/details/:id",
   partConsignmentMasterEdit: "/part-consignment-master/edit/:id",

   // LR Copy
   lrCopyMasterAddForm: "/lr-copy-master/add-form",
   lrCopyMasterView: "/lr-copy-master/view",
   lrCopyMasterEdit: "/lr-copy-master/edit/:id",

   // COMPANY MASTER
   CompanyMasterAddForm: "/company-master/add-form",
   CompanyMasterView: "/company-master/view",
   CompanyMasterEdit: "/company-master/edit/:id",

   // ADHOC TRIP
   adhocTripAdd: "/trip/adhoc/add",
   adhocTripView: "/trip/adhoc/view",
   adhocTripEdit: "/trip/adhoc/edit/:id",

   // CONTRACTUAL TRIP
   contaractualTripAdd: "/trip/contractual/add",
   contractualTripView: "/trip/contractual/view",

   contractualTripEdit: "/trip/contractual/edit/:id",

   tripDetails: "/trip/details/:id",

   tripInvoice: "/trip/invoice/:id",

   // EXPENSE TYPE MASTER UNDER TRIP
   expenseTypeAddForm: "/trip/expense-type/add",
   expenseTypeView: "/trip/expense-type/view",
   expenseTypeEdit: "/trip/expense-type/edit/:id",
   // GEO DATA
   countryAddForm: "/geo-data/country/add",
   countryList: "/geo-data/country/view",
   countryEdit: "/geo-data/country/edit/:id",
   zoneAddForm: "/geo-data/zone/add",
   zoneList: "/geo-data/zone/view",
   zoneEdit: "/geo-data/zone/edit/:id",
   stateAddForm: "/geo-data/state/add",
   stateList: "/geo-data/state/view",
   stateEdit: "/geo-data/state/edit/:id",
   cityAddForm: "/geo-data/city/add",
   cityList: "/geo-data/city/view",
   cityEdit: "/geo-data/city/edit/:id",
   pincodeAddForm: "/geo-data/pincode/add",
   pincodeList: "/geo-data/pincode/view",
   pincodeEdit: "/geo-data/pincode/edit/:id",

   // ADHOC VENDOR
   adhocVendorAdd: "/adhoc-vendor/add",
   adhocVendorView: "/adhoc-vendor/view",

   // common pages
   profileView: "/profile",

   // reports
   loadingReport: "/reports/loading-report",
   vehicleShortageSummaryReport: "/reports/vehicle-shortage-summary-report",
   tripExpensesReport: "/reports/trip-expenses-report",
   performanceReport: "/reports/performance-report",
   monthlyLoadingGraph: "/reports/monthly-loading-graph",
   emiReport: "/reports/emi-report",

   // settings & generic masters
   unitManagement: "/settings/units",
   appConfig: "/settings/app-config",
   productClassification: "/settings/product-classification",
   payroll: "/settings/payroll",
   payrollDetails: "/settings/payroll/:id",
   payrollEdit: "/settings/payroll/:id/edit",
   dailyAttendance: "/settings/daily-attendance",
   dailyAttendanceReport: "/settings/daily-attendance/employee/:employeeId/report",
   settingsPreferences: "/settings/preferences",
};
export default RouteNames;
